import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=e140eb3c&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"
import style0 from "./Example.vue?vue&type=style&index=0&id=e140eb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e140eb3c",
  null
  
)

export default component.exports